<template>
  <v-app>
    <Navbar />
    <v-main class="mb-10">
      <router-view />
    </v-main>

    <!-- Footer -->
    <v-footer class="footer custom-footer">
      <div class="footer-curve"></div>
      <v-container>
        <v-row justify="center" class="footer-section">
          <!-- Company Info -->
          <v-col cols="12" sm="5" class="footer-column text-center">
            <h5 class="footer-heading">KSHS Alumni Registration System</h5>
            <p class="footer-text">
              "Join the KSHS Alumni Community! Reconnect, inspire students, and leave a lasting legacy. Register now and shape the future!"            </p>
          </v-col>

          <!-- Quick Links -->
          <v-col cols="12" sm="3" class="footer-column text-center">
            <h4 class="footer-heading">Quick Links</h4>
            <ul class="footer-links">
              <li><a href="https://kshs.academy" target="_blank">KSHS Academy</a></li>
              <li><a href="https://tda-int.org" target="_blank">TDA Website</a></li>
            </ul>
          </v-col>

          <!-- Contact Info -->
          <v-col cols="12" sm="4" class="footer-column text-center">
            <h4 class="footer-heading">Contact Us</h4>
            <p class="footer-text">
            <v-icon large class="social-icon">mdi-phone</v-icon>
            (+251) 344 40 09 99</p>
         
          <p class="footer-text">
            <v-icon large class="social-icon">mdi-email</v-icon>
            info@kshs.academy</p>

          <div class="social-icons">
            <a
                href="https://web.facebook.com/KallaminoSHS" 
                target="_blank"
                >
                <v-icon large class="social-icon">mdi-facebook</v-icon>
          </a>             <v-icon large class="social-icon">mdi-twitter</v-icon>
              <v-icon large class="social-icon">mdi-linkedin</v-icon>
            </div>
          </v-col>
        </v-row>

        <!-- Footer Bottom -->
        <v-row justify="center">
          <v-col class="text-center mt-8">
            <div class="footer-bottom">
              &copy; {{ new Date().getFullYear() }} — <strong>TDA IT Team.</strong>
              <br />
              <span>All Rights Reserved.</span>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-footer>
  </v-app>
</template>

<script>
import Navbar from './components/AppNavbar.vue';
export default {
  components: {
    Navbar
  }
}
</script>

<style scoped>
/* General Footer Styles */
.custom-footer {
  background: linear-gradient(45deg, rgb(255, 6, 18) 0%, #390100 100%);
  color: #fff;
  padding: 100px 0;
  border-top: 15px solid #03a9f4;
  position: relative;
  overflow: hidden;
  box-shadow: 0 25px 80px rgba(0, 0, 0, 0.5);
  border-radius: 30px 30px 0 0;
  z-index: 2;
  font-family: 'Roboto', sans-serif;
}

.footer-section {
  margin-bottom: 60px;
  z-index: 3;
}

.footer-column {
  padding: 40px;
  transition: transform 0.5s ease, box-shadow 0.5s ease, filter 0.5s ease;
  cursor: pointer;
  z-index: 3;
}

.footer-column:hover {
  transform: translateY(-12px); /* Smooth elevation on hover */
  box-shadow: 0 35px 80px rgb(8, 82, 131); /* More prominent shadow effect */
  filter: brightness(1.2); /* Slight brightness increase */
  border-top-left-radius: 100px;
  border-bottom-right-radius: 100px;
}

.footer-heading {
  font-family: 'Roboto', sans-serif;
  font-size: 3rem;
  font-weight: 700;
  color: #fff;
  margin-bottom: 20px;
  text-transform: uppercase;
  text-shadow: 0 0 8px rgba(255, 0, 0, 0.6);
  transition: color 0.3s ease, letter-spacing 0.3s ease;
}

.footer-heading:hover {
  color: #ffffff;
  letter-spacing: 3px;
  text-shadow: 0 0 20px rgba(8, 64, 90, 0.9);
}

.footer-text {
  font-size: 1.4rem;
  color: #ddd;
  margin-bottom: 18px;
  line-height: 1.8;
  font-weight: 500;
  letter-spacing: 0.5px;
  transition: opacity 0.3s ease;
}

.footer-text:hover {
  opacity: 0.85;
}

.footer-links {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-links li {
  margin-bottom: 18px;
}

.footer-links a {
  color: #fff;
  text-decoration: none;
  font-weight: 600;
  transition: color 0.3s ease, transform 0.3s ease;
  font-size: 1.3rem;
}

.footer-links a:hover {
  color: #f40303;
  transform: scale(1.1);
}

.social-icons {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}

.social-icon {
  color: #fff;
  margin: 0 18px;
  transition: transform 0.4s ease, color 0.4s ease, box-shadow 0.4s ease;
  font-size: 3rem;
  cursor: pointer;
}

.social-icon:hover {
  transform: scale(1.4);
  color: #03a9f4;
  box-shadow: 0 0 25px rgba(0, 169, 244, 0.5);
}

.footer-bottom {
  font-size: 1.5rem;
  color: #ddd;
  text-transform: uppercase;
  letter-spacing: 2px;
  font-weight: 400;
  opacity: 0.9;
  transition: opacity 0.3s ease, letter-spacing 0.3s ease;
}

.footer-bottom:hover {
  opacity: 1;
  letter-spacing: 5px;
}

/* Curved Background Styling */
.footer-curve {
  position: absolute;
  top: -10px;
  left: 0;
  right: 0;
  height: 100px;
  background: #390100;
  z-index: 1;
  border-radius: 50% 50% 0 0;
  box-shadow: 0 25px 50px rgba(4, 58, 120, 0.825);
  transform: scaleY(-1);
  animation: curveAnimation 9s ease-in-out infinite;
}

/* Animated Background */
@keyframes curveAnimation {
  0% {
    transform: scaleY(-1);
  }
  50% {
    transform: scaleY(1);
  }
  100% {
    transform: scaleY(-1);
  }
}

/* Responsive Adjustments */
@media (max-width: 600px) {
  .footer-heading {
    font-size: 2.5rem;
  }

  .footer-text {
    font-size: 1.1rem;
  }

  .footer-curve {
    height: 250px;
    top: -180px;
  }

  .social-icon {
    font-size: 2.5rem;
  }
}
</style>
